import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
})

// Database types for better TypeScript support
export type Database = {
  public: {
    Tables: {
      style_analyses: {
        Row: {
          id: string
          user_id: string
          platform: string
          source_url: string
          analysis_data: any
          created_at: string
        }
        Insert: {
          id?: string
          user_id: string
          platform: string
          source_url: string
          analysis_data: any
          created_at?: string
        }
        Update: {
          id?: string
          user_id?: string
          platform?: string
          source_url?: string
          analysis_data?: any
          created_at?: string
        }
      }
      outfit_feedback: {
        Row: {
          id: string
          user_id: string
          outfit_id: string
          feedback_type: 'love' | 'dislike' | 'comment'
          comment: string | null
          specific_feedback: any | null
          created_at: string
        }
        Insert: {
          id?: string
          user_id: string
          outfit_id: string
          feedback_type: 'love' | 'dislike' | 'comment'
          comment?: string | null
          specific_feedback?: any | null
          created_at?: string
        }
        Update: {
          id?: string
          user_id?: string
          outfit_id?: string
          feedback_type?: 'love' | 'dislike' | 'comment'
          comment?: string | null
          specific_feedback?: any | null
          created_at?: string
        }
      }
      outfit_recommendations: {
        Row: {
          id: string
          user_id: string
          outfit_id: string
          recommendation_data: any
          created_at: string
        }
        Insert: {
          id?: string
          user_id: string
          outfit_id: string
          recommendation_data: any
          created_at?: string
        }
        Update: {
          id?: string
          user_id?: string
          outfit_id?: string
          recommendation_data?: any
          created_at?: string
        }
      }
      styling_kits: {
        Row: {
          id: string
          user_id: string
          outfit_id: string
          kit_data: any
          created_at: string
        }
        Insert: {
          id?: string
          user_id: string
          outfit_id: string
          kit_data: any
          created_at?: string
        }
        Update: {
          id?: string
          user_id?: string
          outfit_id?: string
          kit_data?: any
          created_at?: string
        }
      }
      user_preference_weights: {
        Row: {
          id: string
          user_id: string
          preference_data: any
          confidence_score: number
          updated_at: string
        }
        Insert: {
          id?: string
          user_id: string
          preference_data: any
          confidence_score?: number
          updated_at?: string
        }
        Update: {
          id?: string
          user_id?: string
          preference_data?: any
          confidence_score?: number
          updated_at?: string
        }
      }
    }
  }
}